import { useMount } from 'react-use';

import { Button, StyledMargin } from '@dreryk/react-components';

import { invoiceCreateModalTranslationKeys } from '../../../translations';

type InvoiceCreateFormCompanyIdentificationDetailsCentralStatisticalOfficeButtonProps = {
   readonly onClick: VoidFunction;
   readonly triggerClickOnMount?: boolean;
};

export const InvoiceCreateFormCompanyIdentificationDetailsCentralStatisticalOfficeButton = (
   props: InvoiceCreateFormCompanyIdentificationDetailsCentralStatisticalOfficeButtonProps
): JSX.Element => {
   useMount(() => {
      if (props.triggerClickOnMount) {
         props.onClick();
      }
   });

   return (
      <StyledMargin top={26}>
         <Button
            label={invoiceCreateModalTranslationKeys.downloadDataFromCentralStatisticalOffice}
            testId={'downloadDataFromCentralStatisticalOffice'}
            onClick={props.onClick}
         />
      </StyledMargin>
   );
};
